import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'nallian-shared-ui/lib/components';
import { FEATURE_TABS } from '../../constants';

const FeatureRoles = ({ value, rootUrl }) => (
  <span>
    {value?.map((v, i) => (
      <span key={v.id}>
        <Link to={`${rootUrl}/roles/${v.id}/${FEATURE_TABS.DETAILS}`}>{v.name}</Link>
        {i < value?.length - 1 ? ', ' : ''}
      </span>
    ))}
  </span>
);

FeatureRoles.propTypes = {
  value: PropTypes.array.isRequired,
  rootUrl: PropTypes.string.isRequired,
};

export default FeatureRoles;
